import { AES256_KEY_SPEC } from "../../constants";

export interface SymmetricKeyDerivationOptions {
	privateKey: CryptoKey;
	publicKey: CryptoKey;
	permissions?: KeyUsage[];
}

export async function deriveSymmetricKey(
	options: SymmetricKeyDerivationOptions,
): Promise<CryptoKey> {
	const {
		privateKey,
		publicKey,
		permissions = ["encrypt", "decrypt"],
	} = options;

	return crypto.subtle.deriveKey(
		{
			name: "ECDH",
			public: publicKey,
		},
		privateKey,
		AES256_KEY_SPEC,
		true,
		permissions,
	);
}
